<template>
  <div>
    <section class="index-header p-b-15 m-b-15">
      <div class="level index-actions">
        <div class="level-left">
          <div class="level-item">
            <h1>Publishing Companies</h1>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <a class="button is-primary is-inverted" @click="close">Back to Publishing Companies</a>
          </div>
        </div>
      </div>
    </section>
    <div class="content single">
      <div class="level page-actions is-marginless p-b-30 is-mobile">
        <div class="level-left">
          <div class="level-item m-r-30">
            <h3 class="m-b-30">{{ publishingCompany.name }}</h3>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <PublishingCompanyEditButton
              :publishingCompany="publishingCompany"
              v-if="$can.includes('update-publishing-companies')"
            />
          </div>
        </div>
      </div>
      <section class="section is-paddingless">
        <div class="columns is-marginless">
          <aside class="column is-3 is-paddingless">
            <div class="aside-inner">
              <section class="m-b-30 single-aside-details--data">
                <fieldset>
                  <div class="field">
                    <label class="label">Contact</label>
                    <p>
                      <router-link
                        v-if="publishingCompany.contact"
                        :to="{name: 'contacts.show', params: {id: publishingCompany.contact.id, propped: publishingCompany.contact}}"
                      >{{ publishingCompany.contact.full_name }}</router-link>
                      <span v-else>...</span>
                    </p>
                  </div>
                  <div class="field">
                    <label class="label">Phone</label>
                    <p>{{ publishingCompany | orBlank('phone') }}</p>
                  </div>
                  <div class="field">
                    <label class="label">Website</label>
                    <p>
                      <a
                        v-if="publishingCompany.website"
                        v-bind:href="publishingCompany.website"
                        target="_blank"
                      >{{ publishingCompany.website }}</a>
                      <span v-else>...</span>
                    </p>
                  </div>
                  <div class="field">
                    <label class="label">Location</label>
                    <p>
                      <span v-if="publishingCompany.address_line1">
                        {{ publishingCompany.address_line1 }}
                        <br>
                      </span>
                      <span v-if="publishingCompany.address_line2">
                        {{ publishingCompany.address_line2 }}
                        <br>
                      </span>
                      <span
                        v-if="publishingCompany.address_city"
                      >{{ publishingCompany.address_city }},</span>
                      <span
                        v-if="publishingCompany.address_state"
                      >{{ publishingCompany.address_state }}</span>
                      <span
                        class="m-l-5"
                        v-if="publishingCompany.address_zip"
                      >{{ publishingCompany.address_zip }}</span>
                      <br>
                      {{ publishingCompany.address_country }}
                    </p>
                  </div>
                </fieldset>
              </section>
              <section class="m-b-30 single-aside-details--tags">
                <label class="label">Tags</label>
                <tag-control taggableType="publishingcompany" :taggableId="publishingCompany.id"/>
              </section>
            </div>
          </aside>
          <div class="column is-9 is-paddingless">
            <note-control :notableId="publishingCompany.id" notableType="publishing_company"></note-control>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

import { PUBLISHING_COMPANY_READ } from '@/store/actions'
import store from '@/store'

import PublishingCompanyEditButton from '@/components/PublishingCompanyEditButton'

export default {
  name: 'PublishingCompanyShow',
  components: {
    PublishingCompanyEditButton
  },
  props: {
    propped: Object
  },

  data() {
    return {
      publishingCompany: null
    }
  },

  created() {
    this.publishingCompany = Object.assign({}, this.model)
  },

  computed: {
    model: function () {
      if (this.$store.state.publishingCompany.publishingCompany.id) return Object.assign({}, this.$store.state.publishingCompany.publishingCompany)
      if (this.propped) return Object.assign({}, this.propped)

      return {}
    }
  },

  watch: {
    model: function (newValue, oldValue) {
      this.publishingCompany = Object.assign({}, newValue)
    }
  },

  beforeRouteEnter: function (to, from, next) {
    store.dispatch(PUBLISHING_COMPANY_READ, to.params.id)
    next()
  },

  beforeRouteUpdate: function (to, from, next) {
    store.dispatch(PUBLISHING_COMPANY_READ, to.params.id)
    next()
  },

  methods: {
    close() {
      this.$router.push({ name: 'publishing-companies.index' })
    }
  }
}
</script>
